import React from 'react';
import Swal from 'sweetalert2';
import { Provider } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import { ThemeProvider } from 'styled-components';
import { QueryClientProvider } from 'react-query';

import airboTheme from '../../themes/airbo';
import queryClient from '../../lib/queryClient';
import store from '../../lib/redux/store';

const ReactSwal = withReactContent(Swal);

export default function Modal({
  component,
  width,
  padding = '20px',
  allowOutsideClick = true,
  allowEscapeKey = true,
}) {
  return ReactSwal.fire({
    html: (
      <Provider store={store}>
        <ThemeProvider theme={airboTheme}>
          <QueryClientProvider client={queryClient}>
            {component}
          </QueryClientProvider>
        </ThemeProvider>
      </Provider>
    ),
    showConfirmButton: false,
    allowOutsideClick,
    allowEscapeKey,
    width,
    padding,
  });
}
